(function () {

    angular.module('tmx-app').controller('requestsCtrl', ['$mdSidenav','menu', '$state', 'RequestService','tmxUtility', 
    
        function RequestsCtrl( $mdSidenav, menu,$state, RequestService,tmxUtility) {

            var requestVM = this;

            var exists = tmxUtility.exists;
            var copy = tmxUtility.copy;
            requestVM.formatDate = tmxUtility.formatDateForCompany;
            requestVM.menu=menu;
            
            requestVM.editPermission = tmxUtility.checkPermission('Private.Requests','Edit');
        //#region ------ Grid Initializations and methods------------

            var gridColumns = [              
                {
                    field: "RequestType",
                    title: "Request Type",
                    type: "text",
                    template: "<md-button ng-disabled='!RequestsCtrl.editPermission' class='tmx-primary-text-grid'  ng-click='RequestsCtrl.clickEdit(dataItem)' ng-bind='dataItem.RequestType'></md-button>",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('RequestType')}\" >{{'RequestType' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"RequestType\")' ></i></span>"
                },
                {
                    field: "EntityStatus",
                    title: "Action",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('EntityStatus')}\" >{{'Action' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"EntityStatus\")' ></i></span>"
                },
            // {
            //     field: "UserTypeLkp",
            //     title: "UserType",
            //     type: "select",
            //     data: Users.userType,
            //     isNumber: true,
            //     headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('UserTypeLkp')}\" >{{'UserType' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"UserTypeLkp\")' ></i></span>"
            // },
                {
                    field: "CreatedBy",
                    title: "Creator",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('CreatedBy')}\" >{{'Creator' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"CreatedBy\")' ></i></span>"
                },
                {
                    field: "CreatedDate",
                    title: "RequestDate",
                    type: "date",
                    search: true,
                    applySearchRangeForThisDate: true,
                    template: "{{dataItem.FormattedCreatedDate}}",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('CreatedDate')}\" >{{'RequestDate' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"CreatedDate\")' ></i></span>"
                },
                {
                    field: "RequestStatus",
                    title: "Status",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('RequestStatus')}\" >{{'Status' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"RequestStatus\")' ></i></span>"
                },
                {
                    field: "ExecutedBy",
                    title: "Executor",
                    type: "text",
                    headerTemplate: "<span  ng-class=\"{ 'filter-active' : RequestsCtrl.isFiltered('ExecutedBy')}\" >{{'Executor' | translate}}<i class='fa fa-filter' ng-if='RequestsCtrl.isFiltered(\"ExecutedBy\")' ></i></span>"
                },
            ];

            requestVM.cols = gridColumns;
            requestVM.gridColumns = angular.copy(gridColumns);

            requestVM.mainGridOptions = {
                dataSource: {
                    transport: {
                        read: function (o) {
                            if (angular.isDefined(requestVM.searchClear) && requestVM.searchClear == false) {
                                if (exists(requestVM.o)) {
                                    copy(requestVM.o.data, ["filter"], o.data);
                                }
                            }
                            requestVM.searchClear = false;
                            if (!o.fromSideNav) {
                                if ($state.searchClear) {
                                    requestVM.searchClear = true;
                                    $state.searchClear = undefined;
                                }
                            }
                            else {
                                o.data.firstPage = true;
                            }
                            requestVM.o = angular.copy(o);
                            if (requestVM.o.data.firstPage) {
                                selected();
                            }
                            requestVM.filters = requestVM.o.data.filter;
                            RequestService.getByParams(o, true).then(function (response) {
                                parseResppnse(response.data);
                                o.success(response);
                            });
                        },
                        dataType: "json"
                    },
                    schema: {
                        data: "data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,

                    sort: [{ field: "CreatedDate", dir: "desc" }],
                },
            // selectable: "multiple, row",
                pageable: {
                    refresh: true,
                    pageSizes: true,
                    pageSize: 10,
                    buttonCount: 5
                },
                sortable: true,
                scrollable: false,
                columns: requestVM.gridColumns
            };

            function parseResppnse(data){
                data.forEach(function(dataItem){                                                                            
                    dataItem.FormattedCreatedDate= requestVM.formatDate(dataItem.CreatedDate);                  
                });                                
            }

            requestVM.bulk = [];
            requestVM.container = {};
            $state.data = {
                grid: requestVM.container
            };

            function selected() {
                var dataSource = requestVM.container.userGrid.dataSource;
                if (angular.isDefined(requestVM.o) && angular.isDefined(dataSource) &&
                requestVM.o.data.firstPage && dataSource.page() != 1) {//implies data loaded into grid is just the firt page data
                    dataSource.page(1);
                }
            }

        //#endregion

        //#region ----------Scope Functions-----------------

            requestVM.toggle = function (navID) {
                $mdSidenav(navID).toggle().then(function () { });
            };

            requestVM.isOpen = function (navID) {
                return $mdSidenav(navID).isOpen();
            };

        //#endregion

            requestVM.onChildState = function() {
                if ($state.current.name.indexOf(".add") > 0 || $state.current.name.indexOf(".edit") > 0) {
                    return true;
                }
            };

            requestVM.clickEdit = function(item) {
                $state.go($state.current.name + ".edit", {"Id": item.RequestId});
            };

        }]);
})();
